import { Client } from '../../client';

import { Repository } from './repository';

/**
 * @private
 */
export class OfflineRepository extends Repository {
  clear() {
    this._throwNotImplementedError();
  }

  _throwNotImplementedError() {
    throw new Error('Method of OfflineRepository not implemented');
  }

  // protected methods

  _getAppKey() {
    return Client.sharedInstance().appKey;
  }
}



// WEBPACK FOOTER //
// /home/travis/build/Kinvey/js-sdk/src/core/datastore/repositories/offline-repository.js